/**
 * Merklisten-Seite. Wird nur von sections/main-wishlist.liquid geladen,
 * damit dieser Code nicht auf jeder Shop-Seite mitläuft.
 * Setzt assets/wishlist.js (window.SOWishlist) voraus.
 */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  if (!customElements.get('wishlist-page')) {
    customElements.define(
      'wishlist-page',
      class extends HTMLElement {
        connectedCallback() {
          // Diese Datei wird aus der Sektion geladen und läuft damit früher als
          // assets/wishlist.js am Body-Ende. Deshalb ggf. auf die API warten.
          if (window.SOWishlist) {
            this.init();
          } else {
            document.addEventListener(
              'wishlist:ready',
              function () {
                this.init();
              }.bind(this),
              { once: true }
            );
          }
        }

        init() {
          this.api = window.SOWishlist;
          if (!this.api) return;

          // Theme-Icons aus dem <template> der Sektion einlesen
          this.icons = {};
          var tpl = document.querySelector('template[data-wl-icons]');
          if (tpl) {
            Array.prototype.forEach.call(tpl.content.querySelectorAll('[data-icon]'), function (el) {
              this.icons[el.getAttribute('data-icon')] = el.innerHTML;
            }, this);
          }

          this.sidebar = this.querySelector('[data-wl-sidebar]');
          this.main = this.querySelector('[data-wl-main]');
          this.notice = this.querySelector('[data-wl-notice]');

          this.shared = null;
          var code = new URLSearchParams(window.location.search).get(this.api.SHARE_PARAM);
          if (code) this.shared = this.api.decodeShare(code);

          if (!this.api.available && !this.shared) {
            this.main.innerHTML =
              '<p class="wishlist-empty">Merklisten brauchen lokalen Speicher. Bitte aktiviere Cookies/lokalen Speicher für solaroutlet.de.</p>';
            if (this.sidebar) this.sidebar.hidden = true;
            return;
          }

          this.render = this.render.bind(this);
          document.addEventListener('wishlist:change', this.render);
          this.addEventListener('click', this.onClick.bind(this));
          this.addEventListener('change', this.onChange.bind(this));
          this.render();
        }

        disconnectedCallback() {
          document.removeEventListener('wishlist:change', this.render);
        }

        /* ------------------------------------------------------- Interaktion */

        onClick(e) {
          var t = e.target;
          var el;

          if ((el = t.closest('[data-wl-select]'))) {
            e.preventDefault();
            this.api.setActiveList(el.getAttribute('data-wl-select'));
            return;
          }
          if (t.closest('[data-wl-new]')) {
            e.preventDefault();
            // Liste mit Standardnamen anlegen und den Namen direkt zum Tippen
            // öffnen, statt vorher in einem Browser-Dialog danach zu fragen.
            this.api.createList('');
            setTimeout(
              function () {
                this.startRename();
              }.bind(this),
              0
            );
            return;
          }
          if (t.closest('[data-wl-rename]')) {
            e.preventDefault();
            this.startRename();
            return;
          }
          if (t.closest('[data-wl-delete]')) {
            e.preventDefault();
            var cur = this.api.getActiveList();
            if (!cur) return;
            if (window.confirm('Merkliste „' + cur.name + '" wirklich löschen?')) this.api.deleteList(cur.id);
            return;
          }
          if ((el = t.closest('[data-wl-remove]'))) {
            e.preventDefault();
            this.api.remove(el.getAttribute('data-wl-remove'));
            return;
          }
          if (t.closest('[data-wl-share]')) {
            e.preventDefault();
            this.share();
            return;
          }
          if (t.closest('[data-wl-import]')) {
            e.preventDefault();
            if (this.shared) {
              var created = this.api.importShared(this.shared);
              if (created) {
                this.shared = null;
                history.replaceState({}, '', window.location.pathname);
                this.toast('Als eigene Merkliste gespeichert.');
                this.render();
              }
            }
            return;
          }
          if (t.closest('[data-wl-addall]')) {
            e.preventDefault();
            this.addAll(t.closest('[data-wl-addall]'));
            return;
          }
        }

        onChange(e) {
          var q = e.target.closest('[data-wl-qty]');
          if (q) this.api.setQty(q.getAttribute('data-wl-qty'), q.value);
        }

        share() {
          var list = this.api.getActiveList();
          if (!list || !list.items.length) {
            this.toast('Diese Merkliste ist noch leer.');
            return;
          }
          var res = this.api.shareUrl(list.id, window.location.pathname);
          if (!res) return;
          if (res.tooLong) {
            this.toast('Zu viele Produkte für einen Link. Bitte die Liste aufteilen.');
            return;
          }
          var done = function () {
            this.toast('Link kopiert – jetzt teilbar.');
          }.bind(this);
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(res.url).then(done, function () {
              window.prompt('Link zum Teilen:', res.url);
            });
          } else {
            window.prompt('Link zum Teilen:', res.url);
          }
        }

        addAll(btn) {
          var label = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Wird hinzugefügt …';
          this.api.addAllToCart().then(
            function (res) {
              btn.disabled = false;
              btn.textContent = label;
              if (res.error) {
                this.toast('Warenkorb konnte nicht aktualisiert werden.');
              } else if (!res.added) {
                this.toast('Kein Artikel verfügbar.');
              } else {
                var msg = res.added + (res.added === 1 ? ' Artikel' : ' Artikel') + ' im Warenkorb.';
                if (res.skipped.length) msg += ' Übersprungen: ' + res.skipped.join(', ') + '.';
                this.toast(msg);
                setTimeout(function () {
                  window.location.href =
                    (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
                }, 900);
              }
            }.bind(this)
          );
        }

        toast(msg) {
          if (!this.notice) return;
          this.notice.textContent = msg;
          this.notice.hidden = false;
          clearTimeout(this._t);
          this._t = setTimeout(
            function () {
              this.notice.hidden = true;
            }.bind(this),
            5000
          );
        }

        // Namen direkt auf der Seite bearbeiten: die Überschrift wird gegen ein
        // Eingabefeld getauscht. Enter/Verlassen speichert, Escape verwirft.
        startRename() {
          if (this.editing) return;
          var list = this.api.getActiveList();
          if (!list) return;
          var titleEl = this.main.querySelector('[data-wl-title]');
          if (!titleEl) return;

          var input = document.createElement('input');
          input.type = 'text';
          input.className = 'wishlist-title-input';
          input.value = list.name;
          input.setAttribute('aria-label', 'Name der Merkliste');
          input.setAttribute('maxlength', '80');
          titleEl.replaceWith(input);

          this.editing = true;
          input.focus();
          input.select();

          var finish = function (save) {
            if (!this.editing) return;
            this.editing = false;
            if (save) {
              this.api.renameList(list.id, input.value);
              // renameList löst wishlist:change aus -> render() baut neu auf.
            } else {
              this.render();
            }
          }.bind(this);

          input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
              e.preventDefault();
              finish(true);
            } else if (e.key === 'Escape') {
              e.preventDefault();
              finish(false);
            }
          });
          input.addEventListener('blur', function () {
            finish(true);
          });
        }

        /* ---------------------------------------------------------- Rendering */

        render() {
          // Während der Namenseingabe nicht neu aufbauen – sonst verschwindet
          // das Eingabefeld mitten im Tippen.
          if (this.editing) return;
          if (this.shared) {
            this.renderSidebar(true);
            this.renderShared();
            return;
          }
          this.renderSidebar(false);
          this.renderActive();
        }

        renderSidebar(sharedMode) {
          if (!this.sidebar) return;
          var lists = this.api.available ? this.api.getLists() : [];
          var active = this.api.available ? this.api.getActiveList() : null;

          var items = lists
            .map(function (l) {
              var on = !sharedMode && active && l.id === active.id;
              return (
                '<li><a href="#" data-wl-select="' +
                esc(l.id) +
                '" class="wishlist-nav__item' +
                (on ? ' is-active' : '') +
                '"><span class="wishlist-nav__name">' +
                esc(l.name) +
                '</span><span class="wishlist-nav__meta">' +
                l.items.length +
                (l.items.length === 1 ? ' Produkt' : ' Produkte') +
                '</span></a></li>'
              );
            })
            .join('');

          this.sidebar.innerHTML =
            '<button type="button" class="button wishlist-new" data-wl-new>+ Neue Merkliste</button>' +
            (items ? '<ul class="wishlist-nav">' + items + '</ul>' : '');
        }

        renderShared() {
          var shared = this.shared;
          this.main.innerHTML =
            '<div class="wishlist-head">' +
            '<h1 class="wishlist-title">' + esc(shared.name) + '</h1>' +
            '<p class="wishlist-shared-hint">Geteilte Merkliste – schreibgeschützt.</p>' +
            '<button type="button" class="button" data-wl-import>Als eigene Merkliste speichern</button>' +
            '</div><div data-wl-items></div>';
          this.renderItems(
            shared.handles.map(function (h) {
              return { handle: h, qty: 1 };
            }),
            true
          );
        }

        renderActive() {
          var list = this.api.getActiveList();
          if (!list) {
            this.main.innerHTML =
              '<div class="wishlist-head"><h1 class="wishlist-title">Merkliste</h1></div>' +
              '<p class="wishlist-empty">Noch keine Merkliste. Klicke bei einem Produkt auf das Herz – die Liste wird dann automatisch angelegt.</p>';
            return;
          }

          this.main.innerHTML =
            '<div class="wishlist-head">' +
            '<h1 class="wishlist-title wishlist-title--editable" data-wl-title data-wl-rename title="Zum Umbenennen klicken">' +
            esc(list.name) +
            '</h1>' +
            '<div class="wishlist-actions">' +
            '<button type="button" class="wishlist-action" data-wl-share>Teilen</button>' +
            '<button type="button" class="wishlist-action" data-wl-rename>Umbenennen</button>' +
            '<button type="button" class="wishlist-action wishlist-action--danger" data-wl-delete>Löschen</button>' +
            '</div></div><div data-wl-items></div>';

          this.renderItems(list.items, false);
        }

        // Markup bewusst identisch zum Warenkorb (sections/main-cart.liquid):
        // Tabelle .cart-items mit .product-cart-item, quantity-selector und
        // Papierkorb-Icon. Dadurch greifen cart.css und app.css unverändert.
        renderItems(items, readOnly) {
          var host = this.main.querySelector('[data-wl-items]');
          if (!host) return;

          if (!items.length) {
            host.innerHTML =
              '<p class="wishlist-empty">Diese Merkliste ist leer. Klicke bei einem Produkt auf das Herz.</p>';
            return;
          }

          host.innerHTML = '<p class="wishlist-loading">Produkte werden geladen …</p>';

          Promise.all(
            items.map(
              function (it) {
                return this.api.fetchProduct(it.handle).then(function (p) {
                  return { item: it, product: p };
                });
              }.bind(this)
            )
          ).then(
            function (rows) {
              var sum = 0;
              var body = rows
                .map(function (row) {
                  var it = row.item;
                  var p = row.product;
                  var handle = esc(it.handle);

                  if (!p) {
                    return (
                      '<tr class="wishlist-row--gone">' +
                      '<td class="product-name"><div class="product-cart-item">' +
                      '<div><span class="cart-product-link">Produkt nicht mehr verfügbar</span>' +
                      '<div class="product-cart-item-options">Es wurde aus dem Sortiment genommen.</div>' +
                      (readOnly ? '' : this.removeLink(handle, 'cart-remove-mobile')) +
                      '</div></div></td>' +
                      '<td class="product-quantity">' +
                      (readOnly ? '' : this.removeLink(handle, 'cart-remove-desktop')) +
                      '</td>' +
                      '<td class="product-subtotal"></td></tr>'
                    );
                  }

                  var qty = Math.max(1, it.qty || 1);
                  var anfrage = !!p.preis_auf_anfrage;
                  if (!anfrage) sum += (p.price || 0) * qty;
                  var available = (p.variants || []).some(function (v) {
                    return v.available;
                  });
                  var img = p.featured_image
                    ? '<img src="' +
                      esc(this.api.imgUrl(p.featured_image, 200)) +
                      '" alt="" width="100" height="100" loading="lazy">'
                    : '';

                  return (
                    '<tr>' +
                    '<td class="product-name">' +
                    '<div class="product-cart-item">' +
                    '<div class="product-cart-item-image"><a href="' + esc(p.url) + '">' + img + '</a></div>' +
                    '<div>' +
                    '<a href="' + esc(p.url) + '" class="cart-product-link">' + esc(p.title) + '</a>' +
                    '<div class="product-cart-item-options wishlist-stock' + (available ? '' : ' is-out') + '">' +
                    (available ? 'Verfügbar' : 'Derzeit nicht verfügbar') +
                    '</div>' +
                    (readOnly
                      ? ''
                      : this.qtySelector(handle, qty, 'cart-update-mobile') +
                        this.removeLink(handle, 'cart-remove-mobile')) +
                    '</div></div></td>' +
                    '<td class="product-quantity">' +
                    (readOnly ? '' : this.qtySelector(handle, qty) + this.removeLink(handle, 'cart-remove-desktop')) +
                    '</td>' +
                    '<td class="product-subtotal"><span class="price"><span class="amount">' +
                    (anfrage ? 'Preis auf Anfrage' : this.api.money((p.price || 0) * qty)) +
                    '</span></span></td></tr>'
                  );
                }, this)
                .join('');

              host.innerHTML =
                '<table class="cart-items no-borders">' +
                '<thead><tr>' +
                '<th class="product-name">Produkt</th>' +
                '<th class="product-quantity">Menge</th>' +
                '<th class="product-total">Gesamt</th>' +
                '</tr></thead>' +
                '<tbody>' + body + '</tbody></table>' +
                (readOnly
                  ? ''
                  : '<div class="thb-cart-collaterals wishlist-summary">' +
                    '<div class="wishlist-summary__row"><span>Summe</span>' +
                    '<span class="price"><span class="amount">' + this.api.money(sum) + '</span></span></div>' +
                    '<div class="proceed-to-checkout">' +
                    '<button type="button" class="button full accent" data-wl-addall>Alle in den Warenkorb</button>' +
                    '</div>' +
                    '<p class="cart-policy-text">Alle Preise inkl. MwSt.</p>' +
                    '</div>');
            }.bind(this)
          );
        }

        // Mengenwähler des Themes. Bewusst OHNE die Klasse 'cart-update' –
        // die wird von cart.js ausgewertet und würde den Warenkorb ändern.
        qtySelector(handle, qty, extraClass) {
          return (
            '<quantity-selector class="quantity small-qty ' + (extraClass || '') + '">' +
            '<button class="minus" type="button" aria-label="Menge verringern">' +
            (this.icons.minus || '&minus;') +
            '</button>' +
            '<input type="number" class="qty" value="' + qty + '" min="1" step="1" data-wl-qty="' + handle + '" aria-label="Menge">' +
            '<button class="plus" type="button" aria-label="Menge erhöhen">' +
            (this.icons.plus || '+') +
            '</button>' +
            '</quantity-selector>'
          );
        }

        removeLink(handle, extraClass) {
          return (
            '<a href="#" class="remove ' + (extraClass || '') + '" data-wl-remove="' + handle + '" aria-label="Entfernen">' +
            (this.icons.trash || '&times;') +
            '</a>'
          );
        }
      }
    );
  }
})();
